<template>
  <div>
    <v-form ref="form">
      <v-row class="ml-2 mr-sm-2" v-if="userCanEdit">
      <v-col lg="12" xl="6" v-if="typeIsCurrency">
      <v-currency-field
          :value="fundingAmount"
          :answerSet="answerSet"
          :question="question"
          :placeholder="question.text"
          :customerId="SelectedCustomer.id"
          :single-line="true"
          :key="question.id"
          @input="emitAnswer"
          :dense="true"
          :rules="[value => !!value || 'This field is required']"
        ></v-currency-field>
      </v-col>
      <v-col lg="12" xl="6" v-if="typeIsSelect">
        <v-select
          :items="items"
          v-model="answerId"
          :label="question.text"
          dense
          :rules="[value => !!value || 'This field is required']"
          required
        ></v-select>
      </v-col>
      <v-col lg="12" xl="6" v-if="typeIsRadio">
        <v-radio-group column dense v-model="answerId" :label="question.text" hide-details class="mt-0">
          <v-radio :label="answer.label" :value="answer.id" v-for="answer in answers" :key="answer.id"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col lg="12" xl="6" v-if="typeIsText">
        <v-text-field
          v-model="textAreaText"
          :label="question.text"

          hide-details
          dense
          @blur="changeUpdate"
          :rules="[value => !!value || 'This field is required']"
          required
        ></v-text-field>
      </v-col>
      <v-col lg="12" xl="6" v-if="typeIsTextArea">
        <v-textarea
          dense
          v-model="textAreaText"
          :label="question.text"
          hide-details
          @blur="changeUpdate"
          :rules="[value => !!value || 'This field is required']"
          required
        ></v-textarea>
      </v-col>
      <v-col lg="12" xl="6" v-if="typeIsRagDate">
        <input-rag-date
          :value="SelectedCustomer.funding"
          :answerSet="answerSet"
          :question="question"
          :customerId="SelectedCustomer.id"
          :dense="true"
        ></input-rag-date>
      </v-col>
      <v-col lg="12" xl="6" v-if="typeIsDate">
        <v-text-field
          v-model="answerDate"
          :label="question.text"
          type="date"
          ref="dateInput"
          :rules="[
            value => !!value || 'This field is required',
            value => value && value <= maxDate || 'Please enter an earlier date',
            value => value && value >= minDate || 'Please enter a later date',
          ]"
          :min="minDate"
          :max="maxDate"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12" v-if="typeIsArray">
        <input-json
          :question="question"
          :value="answeredText"
          :customerId="SelectedCustomer.id"
          :answer-set="answerSet"
        ></input-json>
      </v-col>
    </v-row>
    <v-row no-gutters v-else>
      <v-col>
        <v-list-item dense three-line v-if="typeIsArray">
          <v-list-item-subtitle class="d-block" v-for="(answers, index) in answerArray" :key="index">
            <span class="mr2" v-for="(answer, question) in answers" :key="`${index}-${question}`">
              <strong>{{ question }}: </strong>{{ answer }}
            </span>
          </v-list-item-subtitle>
        </v-list-item>
        <v-list-item dense two-line v-else>
          <v-list-item-content>
            <v-list-item-title>{{ question.text }}</v-list-item-title>
            <v-list-item-subtitle v-if="typeIsText || typeIsRagDate || typeIsDate">
              {{ answeredText }}
            </v-list-item-subtitle>

            <v-list-item-subtitle v-else-if="typeIsTextArea">
              {{ answeredText }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-else-if="typeIsCurrency">{{ answeredText | currency }}</v-list-item-subtitle>
            <v-list-item-subtitle v-else>{{ answerLabel }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
    </v-form>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import VCurrencyField from '../../Widgets/VCurrencyField';
import InputRagDate from '../../Widgets/InputRagDate';
import InputJson from '../../Widgets/InputJson';
import { DateTime } from 'luxon';

export default {
  components: { VCurrencyField, InputRagDate, InputJson },
  name: 'answer-tile',
  data: () => ({
    modal: false,
    textAreaText: null,
    dateText: null
  }),
  props: ['question'],
  computed: {
    ...mapGetters(['SelectedCustomer', 'SelectedReferral', 'UserHasRole']),
    items: function() {
      let answers = _.orderBy(
        _.filter(this.question.answers, answer => answer.enabled === true),
        'value',
        'asc'
      );
      return answers.map(answer => {
        return {
          value: answer.id,
          text: answer.label
        };
      });
    },
    answerArray() {
      if (this.typeIsArray && _.isNull(this.answerText) === false) {
        return JSON.parse(this.answerText);
      } else {
        return [];
      }
    },
    answerSet() {
      return _.isUndefined(this.SelectedCustomer.answerset)
        ? null
        : _.find(this.SelectedCustomer.answerset, ['question.id', this.question.id]);
    },
    answerId: {
      get() {
        return this.isNotFilled(this.answerSet) ? null : this.answerSet.answer.id;
      },
      set(value) {
        this.updateCustomerAnswerSet(this.SelectedCustomer.id, this.answerSet, value, null, this.question.id);
      }
    },
    answerText() {
      return this.isNotFilled(this.answerSet) ? null : this.answerSet.answer.answer_text;
    },
    answer() {
      return this.isNotFilled(this.answerSet) ? null : this.answerSet.answer;
    },
    answeredText() {
      return this.isNotFilled(this.answerSet) ? null : this.answerSet.answer.answer_text;
    },
    answerLabel() {
      return this.isNotFilled(this.answerSet) ? null : this.answerSet.answer.label;
    },
    answers() {
      return _.orderBy(
        _.filter(this.question.answers, answer => answer.enabled === true),
        'value',
        'asc'
      );
    },
    businessId() {
      return this.isNotFilled(this.answerSet) ? null : this.answerSet.answerable_id;
    },
    answerDate: {
      get() {
        return this.isNotFilled(this.answerSet)
          ? new Date().toISOString().substr(0, 10)
          : this.answerSet.answer.answer_text;
      },
      set(value) {
        this.updateCustomerAnswerSet(
          this.SelectedCustomer.id,
          this.answerSet,
          this.question.answers[0].id,
          value,
          this.question.id
        );
      }
    },
    fundingAmount() {
      if (this.question.properties !== 'funding-level') {
        return null;
      }
      return _.isUndefined(this.SelectedCustomer.id)
        ? this.SelectedReferral.requested_amount
        : this.SelectedCustomer.funding;
    },
    minDate() {
      return typeof this.question.min_date !== undefined && this.question.min_date !== null
        ? DateTime.fromFormat(this.question.min_date, 'yyyy-MM-dd').toString()
        : '1900-01-01';
    },
    maxDate() {
      return typeof this.question.max_date !== undefined && this.question.max_date !== null
        ? DateTime.fromFormat(this.question.max_date, 'yyyy-MM-dd').toString()
        : new Date().toISOString().substr(0, 10);
    },
    typeIsText() {
      return (
        this.question.questionType.name === 'text' ||
        this.question.questionType.name === 'phone' ||
        this.question.questionType.name === 'mobile' ||
        this.question.questionType.name === 'number' ||
        this.question.questionType.name === 'experian'
      );
    },
    typeIsTextArea() {
      return this.question.questionType.name === 'textarea';
    },
    typeIsRadio() {
      return this.question.questionType.name === 'radio';
    },
    typeIsSelect() {
      return this.question.questionType.name === 'select';
    },
    typeIsCurrency() {
      return this.question.questionType.name === 'currency';
    },
    typeIsRagDate() {
      return this.question.questionType.name === 'rag_date';
    },
    typeIsDate() {
      return this.question.questionType.name === 'experian_date';
    },
    typeIsArray() {
      return this.question.questionType.name === 'json';
    },
    userCanEdit() {
      return (
        this.UserHasRole('Platform') ||
        this.UserHasRole('Call Centre') ||
        this.UserHasRole('Broker') ||
        (this.UserHasRole('Property Broker') && !this.question.is_critical)
      );
    }
  },
  methods: {
    ...mapActions(['updateAnswerSet', 'setRegistrationAnswer']),
    isNotFilled(value) {
      return _.isUndefined(value) || _.isNull(value);
    },
    changeUpdate() {
      if (_.isUndefined(this.SelectedCustomer.id)) {
        this.emitAnswer(this.question.answers[0].id, this.textAreaText);
        return;
      }
      this.updateAnswerSet({
        id: this.SelectedCustomer.id,
        answerSet: this.answerSet,
        answerId: this.question.answers[0].id,
        answerText: this.textAreaText,
        questionId: this.question.id,
        isCritical: this.question.is_critical
      });
    },
    updateCustomerAnswerSet(id, answerSet, answerId, answerText, questionId) {
      if (_.isUndefined(this.SelectedCustomer.id)) {
        this.emitAnswer(answerId, answerText);
        return;
      }
      this.updateAnswerSet({
        id,
        answerSet,
        answerId,
        answerText,
        questionId,
        isCritical: this.question.is_critical
      });
    },
    emitAnswer(answerId, value) {
      if (_.isUndefined(this.SelectedCustomer.id)) {
        const answer = {
          question_id: this.question.id,
          answer_id: answerId,
          answer_text: value,
          question_slug: this.question.properties
        };
        this.setRegistrationAnswer(answer);
      }
    },
  },
  mounted() {
    this.textAreaText = this.isNotFilled(this.answerSet) ? null : this.answerSet.answer.answer_text;
    this.$refs.form.validate();

  },
};
</script>

<style lang="scss">
.v-input .v-label {
  height: inherit;
}
.v-input {
  font-size: 0.85em;
}
</style>
